import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MyButton from '../../../util/MyButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import dayjs from 'dayjs';

const styles = (theme) => ({
    ...theme,
    avatar: {
      width: 38,
      height: 38,
      marginRight: 5,
    },
    dFlex: {
      display: 'flex',
      alignItems: 'center',
      width: 300,
    },
    moreAction: {
      padding: 7,
      color: '#d7d7d7',
    },
    partnerBag: {
      display: 'inline-block',
      backgroundColor: '#ffd94f',
      padding: '3px 5px',
      borderRadius: 4,
    },
    highlight: {
      marginRight: 5,
      color: '#ff1616',
      fontWeight: 500,
    },
    percentBox: {
      marginRight: 5,
      backgroundColor:'#ffd94f',
      padding: '2px 4px',
      borderRadius: 4,
    },
    yellow: {
      fill: '#ffd94f',
      fontSize: 16,
      alignSelf: 'center',
    },
    ratingCol: {
      display: 'flex',
      alignItems: 'center',
      '& span:first-child': {
        marginRight: 5,
      }
    },
    boxSuccess: {
      padding: '3px 5px',
      color: 'white',
      display: 'inline-block',
      borderRadius: 5,
      backgroundColor: '#1cbb64',
    },
    boxWarning: {
      padding: '3px 5px',
      color: 'white',
      display: 'inline-block',
      borderRadius: 5,
      backgroundColor: '#ffd94f',
    },
    textDark: {
      color: '#4c4c4c',
    }
})

class ProductLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl : null,
      openAuthor: false,
    } 
  }
  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget
    })
  }

  handleClose = () => {
    this.setState({
      anchorEl: null,
    })
  }
  limitContent = (text, count) => {
    return text.slice(0, count) + (text.length > count ? "..." : "");
  }
  htmlToText = (htmlString) => {
    const el = document.createElement('div');
    el.innerHTML = htmlString;
    return el.textContent;
  }
  handleOpenAuthor = () => {
    this.setState({
      openAuthor: true,
    })
  }
  handleCloseAuthor = () => {
    this.setState({
      openAuthor: false,
    })
  }
  render() {
    const { index, classes, post } = this.props;
    const {openAuthor} = this.state;
    const get_cate = post.categories.filter(category => !category.parent);
    const get_cate_children = post.categories.filter(category => category.parent);
  return (
    <tr>
        <td className="alignCenter" style={{width: 50}}>{index} </td>
        <td style={{width: 300}}><div className={classes.dFlex}><Avatar alt={post.title.vi} src={post.featuredImg ? post.featuredImg : '/images/no-image.svg'} className={classes.avatar} /> {post.title.vi}</div></td>
        <td style={{width: 400}}>
          <div className="mb-10">{this.limitContent(this.htmlToText(post.description.vi), 42)}</div>
          <div className="mb-10"><span className="bold">Thẻ tiêu đề: </span>{this.limitContent(this.htmlToText(post.meta_title.vi), 31)}</div>
          <div className="mb-10"><span className="bold">Thẻ mô tả: </span> {this.limitContent(this.htmlToText(post.meta_description.vi), 32)}</div>
          <div className="mb-10"><span className="bold">Thẻ từ khoá: </span>{this.limitContent(this.htmlToText(post.meta_keywords.vi), 30)}</div>
        </td>
        <td style={{width: 200}}>{this.limitContent(post.slug, 80)}</td>
        <td style={{width: 200}}>
           {get_cate.map((category, index1) => (
            <ul className="pixel-list"  key={index1}>
              <li><p><span><small>{category.label}</small></span></p>
                <ul>
              {
                get_cate_children.filter((element) => 
                element.parent.some((item) => item.value === category.value))
                .map(element => {
                    let n = Object.assign({}, element, {'parent': element.parent.filter(
                      item => item.value === category.value
                    )})
                    return n;
                }).map((categoryChild) => (
                  <li key={categoryChild.value}><p><span><small>{categoryChild.label}</small></span></p></li>
                ))
              }
                </ul>
              </li>
            </ul>
          ))}
        </td>
        <td style={{width: 100}}>{post.status === 1 ? 'Công bố' : post.status === 2 ? <div><span>Được bảo vệ bằng mật khẩu</span><br />Mật khẩu: {post.password}</div> : 'Riêng tư'}</td>
        <td>{dayjs(post.createdAt).format('DD/MM/YYYY')}</td>
        <td 
          className="relative" 
          style={{width: 100}}
          onMouseOver={this.handleOpenAuthor} 
          onMouseOut={this.handleCloseAuthor}
        >
          {post.authorId &&
          <>
          <div className="author-avatar flex align-items-center">
            <Avatar alt={post.authorId.fullname} src={post.authorId.imageUrl ? post.authorId.imageUrl : '/images/no-image.svg'} className={classes.avatar} />
          </div>
          <div 
            className={`post-author ${openAuthor ? 'show' : ''}`}
            onMouseOver={this.handleOpenAuthor} 
            onMouseOut={this.handleCloseAuthor}
          >
                <p className="name">{this.limitContent(this.htmlToText(post.authorId.fullname), 18)}</p>
                <p className="email">{post.authorId.email ? this.limitContent(this.htmlToText(post.authorId.email), 25) : 'Không xác định'}</p>
                <p className="phone">{post.authorId.phone ? post.authorId.phone : 'Không xác định'}</p>
          </div>
          </>
          }
        </td>
        <td style={{width: 50}}>{post.viewsCount}</td>
        <td>
          <MyButton 
            tip="Mở rộng" 
            // onClick={this.handleClose} 
            tipClassName={classes.moreAction}
            ariaControls="simple-menu"
            ariaHaspopup="true"
            onClick={this.handleClick}
          >
              <MoreVertIcon />
          </MyButton>
          <Menu
            id="simple-menu"
            anchorEl={this.state.anchorEl}
            keepMounted
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleClose}
          >
           <MenuItem><Link className={classes.textDark} to={`/bai-viet/chinh-sua/${post.postId}`}>Chỉnh sửa</Link></MenuItem>
          </Menu>
        </td>
    </tr>
  )
  }
}

ProductLists.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default connect(null, {  })(withStyles(styles)(ProductLists));
